import { Clock, Phone, Mail, MessageCircle, Truck } from "lucide-react";
import { CONTACT } from "@/data/products";

const StoreInfo = () => (
  <div data-testid="store-info" className="bg-forest text-cream rounded-3xl p-8 md:p-10 border border-[#3E6152] flex flex-col gap-6">
    <div>
      <p className="uppercase text-xs font-semibold tracking-[0.2em] text-gold">Visit the Store</p>
      <h3 className="font-serif text-2xl md:text-3xl font-bold mt-2">खुले हैं, आपके लिए</h3>
    </div>
    <div className="flex items-start gap-3">
      <Clock size={18} className="text-gold mt-0.5 shrink-0" />
      <div>
        <p className="font-semibold text-sm">Store Hours</p>
        <p className="text-cream/70 text-sm">{CONTACT.hours}</p>
      </div>
    </div>
    <div className="flex items-start gap-3">
      <Truck size={18} className="text-gold mt-0.5 shrink-0" />
      <div>
        <p className="font-semibold text-sm">Home Delivery</p>
        <p className="text-cream/70 text-sm">Free delivery on orders above ₹500 within the neighbourhood.</p>
      </div>
    </div>
    <div className="flex flex-col gap-3 pt-4 border-t border-[#3E6152]">
      <a href={CONTACT.phoneHref} data-testid="store-info-phone" className="inline-flex items-center gap-3 text-cream/85 hover:text-gold transition-colors text-sm">
        <Phone size={16} className="text-gold" /> {CONTACT.phone}
      </a>
      <a href={CONTACT.emailHref} data-testid="store-info-email" className="inline-flex items-center gap-3 text-cream/85 hover:text-gold transition-colors text-sm">
        <Mail size={16} className="text-gold" /> {CONTACT.email}
      </a>
      <a
        href={CONTACT.whatsapp}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="store-info-whatsapp"
        className="inline-flex items-center justify-center gap-2 bg-[#25D366] text-white font-semibold text-sm px-6 py-3 rounded-full hover:bg-[#128C7E] transition-colors mt-2"
      >
        <MessageCircle size={16} /> Chat on WhatsApp
      </a>
    </div>
  </div>
);

export default StoreInfo;
